import { Form, Modal, ModalProps, Button, Spin } from 'components/common'

export interface CancelApprovalModalProps extends Omit<ModalProps, 'onOk'> {
  onOk: () => Promise<void>
  onClose: (value: boolean) => void
  loading: boolean
}

export const CancelApprovalModal = ({
  visible,
  onClose,
  onOk,
  loading,
}: CancelApprovalModalProps) => {
  const [form] = Form.useForm()
  const onSubmit = async () => {
    await onOk()
    onClose(false)
  }

  return (
    <Modal
      title={'承認をキャンセルする'}
      visible={visible}
      onCancel={() => onClose(false)}
      onOk={() => {
        form
          .validateFields()
          .then(() => onSubmit())
          .catch((error) => console.error(error))
      }}
      footer={
        <div className="flex justify-end space-x-4">
          <Button onClick={() => onClose(false)} disabled={loading}>
            閉じる
          </Button>
          <Button
            type="primary"
            onClick={() => {
              form
                .validateFields()
                .then(() => onSubmit())
                .catch((error) => console.error(error))
            }}
            disabled={loading}
          >
            実行
          </Button>
        </div>
      }
    >
      <Spin spinning={loading} tip="承認のキャンセルを実行中...">
        <p className="font-bold text-2xl text-center mb-0">
          本当にキャンセルしてよろしいでしょうか？
        </p>
      </Spin>
    </Modal>
  )
}
